<template>
	<div class="container">
<!--    <div class="monikaoshi-top">-->
<!--      <div  class="fanhui" v-if="isShowBack">-->
<!--        <img src="../../../static/images/other-fanhui.png" @click="back" >-->
<!--      </div>-->
<!--    </div>-->
		<div class="kaoshichengji-bg"><img src="../../../static/images/other-collectbg.png" /></div>
		<div class="kaoshichengji-top">
			<div class="fanhui" ></div>
			<div class="tab">考试成绩</div>
		</div>
		<div class="kaoshichengji-mid" >
			<div class="circle">
				<circle-progressbar
					style="width: 2rem;height: 2rem;position: absolute;top: 1rem;left: 50%;margin-left: -1rem;color: rgba(0,0,0,0);font-size: 0;"
					barColor="rgba(255, 55, 52, 1)"
					backgroundColor="rgba(255, 225, 224, 1)"
					:radius="14"
					:progress="fenshu"
					:isAnimation="true"
				></circle-progressbar>
			</div>

			<div class="fenshu">
				{{ fenshu }}
				<p>分</p>
			</div>
			<div class="yuce">
        <p v-if="fenshu>=90">合格</p>
        <p v-else>不合格 </p>
      </div>
		</div>
		<div class="kaoshichengji-bot">
			<div class="kaoshichengji-mids">
				<div class="items" @click="gotowrongpage">
					<div class="left">
						<div class="img"><img src="../../../static/images/other-collectnow.png" /></div>
						<div class="info">
							<div>本次错题</div>
							<div>趁热打铁，及时巩固本次错题</div>
						</div>
					</div>
					<div class="right"><img src="../../../static/images/other-collectgo.png" /></div>
				</div>
				<div class="items" @click="gotochongxinpage">
					<div class="left">
						<div class="img"><img src="../../../static/images/other-collect-all.png" /></div>
						<div class="info">
							<div>重新考试</div>
							<div>发挥失常，再考一次</div>
						</div>
					</div>
					<div class="right"><img src="../../../static/images/other-collectgo.png" /></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import circleProgressbar from 'vue-circleprogressbar';
export default {
	name: 'simulationScore',
	components: {
		circleProgressbar
	},
	data() {
		return {
			kemuType: 1,
			fenshu: 0,
			wrongList:[],
      isShowBack:false
		};
	},
	created() {
    if (this.GetRequest('channel') == 'exejH5') {
      this.isShowBack = true
    }
		document.documentElement.style.fontSize = "625%"
		this.$data.kemuType = this.$route.params.showType;
		this.$data.fenshu = this.$route.params.fenshu;
		this.wrong=this.$route.params.wrong;
    console.log(this.wrongCount)
		// if(this.$route.params.fenshu==null||this.$route.params.wrongList==null){
		// 	this.$router.push({
		// 		name: 'home'
		// 	});
		// 	return
		// }
	},
	methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
		GetRequest(value) {
					return this.$route.query[value];
		},
		// goback() {
		// 	this.$router.push({
		// 		name: 'home'
		// 	});
		// },
		gotopage() {
			this.$router.push({
				name: 'tixingxuanze',
				params: { name: 'item', id: 1 }
			});
		},
		gotowrongpage() {
      if (this.wrong == 0) {
        this.$dialog.alert({
          message: "没有错题信息！"
        });
        return
      }
      this.$router.push({

        name: 'wrongPaper',

        params: {showType: this.$data.kemuType, list: this.wrongList},
        query: {
          userid: this.GetRequest('userid'),
          km: this.GetRequest('km'),
          // cx:this.GetRequest('cx'),  //原有
          cx: this.GetRequest('cx'),  //原有
          licence_id: this.GetRequest('licence_id'),  //修改
          // licence_id:this.GetRequest('cx') == 2 ? "xc" : this.GetRequest('cx') == 3 ? "hc" : this.GetRequest('cx') == 4 ? "kc" : "mtc",  //修改
          appid: this.GetRequest('appid'),
          channel: this.GetRequest('channel'),  //修改
          coachid: this.GetRequest('coachid'),  //修改
          schoolid: this.GetRequest('schoolid'),  //修改
          timestamp: this.GetRequest('timestamp'),  //修改
          sign: this.GetRequest('sign'),  //修改
          paper_id:this.GetRequest('paper_id'),  //修改
        },
      });
    },
		gotochongxinpage() {
			//console.log(this.wrongList)
			this.$router.push({

				name: 'exam',

				params: { showType:this.$data.kemuType },
				query : {
					userid : this.GetRequest('userid'),
					km : this.GetRequest('km'),
					// cx:this.GetRequest('cx'),  //原有
					 cx:this.GetRequest('cx'),  //原有
                    licence_id:this.GetRequest('licence_id'),  //修改
                    // licence_id:this.GetRequest('cx') == 2 ? "xc" : this.GetRequest('cx') == 3 ? "hc" : this.GetRequest('cx') == 4 ? "kc" : "mtc",  //修改
          appid : this.GetRequest('appid'),
          channel:this.GetRequest('channel'),  //修改
          coachid:this.GetRequest('coachid'),  //修改
          schoolid:this.GetRequest('schoolid'),  //修改
          timestamp:this.GetRequest('timestamp'),  //修改
          sign:this.GetRequest('sign'),  //修改

				}

			});

		}
	},
	afterDestory(){
		document.documentElement.style.fontSize = ""
	}
};
</script>
<style scoped >

	>>>.center_text .title{
		color: rgba(0,0,0,0);
	}
</style>
<style lang="scss" scoped>

.container {
	width: 100%;
	font-size: 0.18rem;
	.kaoshichengji-bot {
		width: 100%;
		.items {
			padding-left: 5%;
			width: 90%;
			padding-right: 5%;
			display: flex;
			justify-content: space-between;
			height: 0.66rem;
			border-bottom: 1px solid #e2e2e2;
			.left {
				display: flex;
				.img {
					margin-top: 0.16rem;
					width: 0.23rem;
					height: 0.25rem;
					position: relative;
					img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
					}
				}
				.info {
					div:nth-child(1) {
						color: #242626;
						font-size: 0.16rem;
						margin-top: 0.1rem;
						margin-left: 0.16rem;
					}
					div:nth-child(2) {
						color: #888989;
						font-size: 0.12rem;
						display: flex;
						margin: 0;
						padding: 0;
						margin-left: 0.16rem;
						margin-top: 0.03rem;
						p {
							padding: 0;
							margin: 0;
							color: #0195f7;
							margin-top: 0.02rem;
						}
					}
				}
			}
			.right {
				width: 0.06rem;
				height: 0.11rem;
				position: relative;
				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					margin-top: 0.25rem;
				}
			}
		}
	}
	.kaoshichengji-mid {
		font-size: 0.18rem;
		color: #333333;
		width: 92%;
		margin-left: 4%;
		height: 2.4rem;
		.circle {
			.content .center_text .title {
				color: rgba(0, 0, 0, 0);
				font-size: 0;
			}
		}
		.fenshu {
			text-align: center;
			font-size: 0.4rem;
			color: #fff;
			display: flex;
			justify-content: center;
			p {
				margin: 0;
				padding: 0;
				font-size: 0.16rem;
				margin-top: 0.2rem;
			}
		}
		.yuce {
			color: #fff;
			font-size: 0.18rem;
			margin: 0 auto;
			text-align: center;
			margin-top: 0.1rem;
		}
	}
	.kaoshichengji-bg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3.75rem;
		z-index: -1;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.kaoshichengji-top {
		display: flex;
		width: 100%;
		height: 1.5rem;
		.fanhui {
			z-index: 1;
			position: absolute;
			top: 0.23rem;
			left: 0.23rem;
			width: 0.07rem;
			height: 0.13rem;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.tab {
			position: absolute;
			width: 100%;
			margin: 0 auto;
			color: #fff;
			margin-top: 0.2rem;
			font-size: 0.18rem;
			height: 0.29rem;
			line-height: 0.29rem;
			letter-spacing: 2px;
			text-align: center;
		}
	}
}
</style>
